export default "__VITE_ASSET__BQsjsjlw__"